import { isEmbarcacaoContatosEmpty } from "@/modules/embarcacoes/embarcacoes.types";
import type {
  EmbarcacaoContatos,
  EmbarcacaoContatosState,
} from "@/modules/embarcacoes/embarcacoes.types";
import {
  useEmbarcacaoDetailSection,
  type EmbarcacaoDetailSectionQuery,
} from "./use-embarcacao-detail-section";

const CONTATOS_QUERY: EmbarcacaoDetailSectionQuery<EmbarcacaoContatos> = {
  select: (ficha) => ficha.contatos,
  isEmpty: isEmbarcacaoContatosEmpty,
  secao: "os Contatos",
};

interface UseEmbarcacaoContatosResult extends EmbarcacaoContatosState {
  reload: () => void;
}

/** Consulta os Contatos da embarcação pedida. Somente leitura. */
export function useEmbarcacaoContatos(id: string): UseEmbarcacaoContatosResult {
  const { data, ...state } = useEmbarcacaoDetailSection(id, CONTATOS_QUERY);

  return { ...state, contatos: data };
}
